export default __webpack_public_path__ + "static/media/tropical.09559eab.png";